import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { offeringsDraftRoute } from '..';

export const offeringsDraftMissingRoute = createRoute({
  getParentRoute: () => offeringsDraftRoute,
  path: 'missing',
  component: lazyRouteComponent(() => import('./OfferingsDraftMissingView')),
});
